import { render } from "./product-feature-single-big.vue?vue&type=template&id=cb28a2a4&scoped=true"
import script from "./product-feature-single-big.vue?vue&type=script&lang=js"
export * from "./product-feature-single-big.vue?vue&type=script&lang=js"

import "./product-feature-single-big.vue?vue&type=style&index=0&id=cb28a2a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb28a2a4"]])

export default __exports__